import { apiGet, apiPost, apiDelete, apiPut } from 'api';
import { SpeakerType } from '../types/speaker';

const speaker = {
  get: async (id: number) => {
    const data = await apiGet(`${process.env.REACT_APP_API_URI}/api/speaker/${id}`);
    return data;
  },
  getAll: async () => {
    const data = await apiGet(`${process.env.REACT_APP_API_URI}/api/speaker/all`);
    return data;
  },
  create: async (speaker: SpeakerType) => {
    const data = await apiPost(`${process.env.REACT_APP_API_URI}/api/speaker/create`, speaker);
    return data;
  },
  update: async (speaker: SpeakerType) => {
    const data = apiPut(`${process.env.REACT_APP_API_URI}/api/speaker/update`, speaker);
    return data;
  },
  delete: async (speakerId: number) => {
    const data = await apiDelete(`${process.env.REACT_APP_API_URI}/api/speaker/delete/${speakerId}`);
    return data;
  }
};

export default speaker;
